import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useProducts from '../Admin/useProducts';
import ProductCollection from '../UI/ProductCollection';

/** Newest products. Shares all of its behaviour with HotProducts. */
const NewArrival = ({ layout = 'grid', perPage = 4, columns }) => {
  const location = useLocation();

  const filters = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      category_code: params.get('category') || '',
      product_guide: params.get('guide') || '',
      price_min: params.get('price_min') || '',
      price_max: params.get('price_max') || '',
      min_price: null,
      max_price: null,
      per_page: perPage,
    };
  }, [location.search, perPage]);

  const { products, load, err, fetchproducts } = useProducts(filters);

  return (
    <ProductCollection
      products={products}
      loading={load}
      error={err}
      onRetry={() => fetchproducts(1)}
      layout={layout}
      columns={columns}
      limit={perPage}
      skeletonCount={perPage}
      emptyTitle="No new arrivals yet"
      emptyMessage="New pieces are added every week — check back soon."
    />
  );
};

export default NewArrival;
